export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const TLD_DOMAIN = /^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
export const SUBDOMAIN = /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
